import type { ProLayoutProps } from '@ant-design/pro-components';
import { BizAppConfig } from './application.manifest';
import { getBrandAppName } from './brand';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: '#1890ff',
  layout: 'mix',
  siderWidth: 208,
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  pwa: false,
  title: getBrandAppName(),
  logo: BizAppConfig.appLogo,
  splitMenus: true,
  suppressSiderWhenMenuEmpty: true,
  menu: { defaultOpenAll: true, ignoreFlatMenu: true, autoClose: false },
  className: 'crm-shell crm-content-theme',
  breadcrumbRender: false,
  contentStyle: {
    height: 'calc(100dvh - 44px)',
    overflow: 'auto',
    minWidth: 0,
    padding: 0,
    backgroundColor: '#ffffff',
  },
  token: {
    header: { heightLayoutHeader: 44 },
    pageContainer: { colorBgPageContainer: '#ffffff' },
    bgLayout: '#ffffff',
  },
};
export default Settings;
